module.exports = __webpack_public_path__ + "static/media/organizer_10.3fa934b0.jpg";